import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Store from 'drip/store';
import User from 'drip/user';
import Event from 'drip/event';
import KNB from '@dp/knb';
import OpenItem from './open-item.vue';
import { copyTextToClipboard } from '@/utils/';
import { notifyCalendar } from '@/utils/notifyCalendar';
import event from '@/event';
var envList = ['product', 'beta', 'dev'];
var urlList = [{
  title: '首页',
  url: 'http://h5.51ping.com/app/myshow/'
}, {
  title: '列表页',
  url: 'http://h5.51ping.com/app/myshow/#/list/0'
}, {
  title: '搜索页',
  url: 'http://h5.51ping.com/app/myshow/#/search/'
}, {
  title: '订单列表页',
  url: 'http://h5.51ping.com/app/myshow/#/order-list'
}];
export default {
  // 开发面板页
  name: 'debugger',
  components: {
    'open-item': OpenItem
  },
  data: function data() {
    var swimlane = '';
    // href 中获取泳道地址
    var match = /https?:\/\/(.*)-h5\.51ping\.com.*/ig.exec(location.href);
    if (match && match[1]) {
      swimlane = match[1];
    }
    return {
      // 泳道地址
      swimlane: swimlane,
      // 常用url列表
      urlList: [],
      addUrl: '',
      addUrlTitle: '',
      // 用户信息
      userInfo: null,
      eventUnionIdandroid: '',
      eventIdios: ''
    };
  },
  created: function created() {
    this.setOpenList();
    this.setUserInfo();
  },
  methods: {
    openAppSettings: function openAppSettings() {
      console.log('openAppSettings');
      if (Drip.UA.osName === 'ios') {
        location.href = 'app-settings:';
        // KNB.requestPermission({
        //   type: 'reminder',
        //   sceneToken: 'my-87bff41fea170162',
        //   readonly: true, // 没有权限时是否唤起权限请求面板，默认为 false，false会唤起请求面板
        //   forceJump: true,
        //   success: (res) => {
        //     console.log('openAppSettings success', res)
        //   },
        //   fail: function(res){
        //     console.log('openAppSettings error', res)
        //   },
        // })
      }
    },

    // addCalendarShuxin(){
    //   console.log('addCalendarShuxin')
    //   let startTime = Math.floor((Date.now() / 1000)) + 3600;
    //   let endTime = Math.floor((Date.now() / 1000)) + 3600 * 3;
    //   let description = `我是来自H5的Desc, 时间:${Date().toLocaleString()}`;
    //   KNB.use('movie.addCustomCalendar', {
    //     params: {
    //       eventUnionId: '1111',
    //       sceneToken: 'my-87bff41fea170162',
    //       startTime: startTime,
    //       endTime: endTime,
    //       title: '我是来自H5的Title',
    //       allDay: false,
    //       description: description,
    //       location: '我是来自H5的Location',
    //       alarm: true,
    //       alarmOffset: 0,
    //       alarmOffsets: '600, 1800, 3600',
    //       repeatInterval: '0',
    //       // repeatEndTime: 0,
    //       url: '', // Android不支持
    //       calendarTitle: '' // Android不支持
    //     },
    //     success: function (data) {
    //       alert(JSON.stringify(data))
    //     },
    //     fail: function (error) {
    //       alert(JSON.stringify(error))
    //     }
    //   })
    //   // notifyCalendar({title: 'test-cl', start: 1777032000000, alarmOffsets: '600,1800', eventUnionId: '1234567890', endTime: 1777032060000, })
    // },
    // queryCalendarAndroidShuxin(){
    //   KNB.use('movie.isCalendarEventExist', {
    //     params: {
    //       eventUnionId: '1111',
    //       sceneToken: 'my-87bff41fea170162',
    //     },
    //     success: function (data) {
    //       alert(JSON.stringify(data))
    //       console.log('queryCalendarAndroidShuxin res', data)
    //     },
    //     fail: function (error) {
    //       alert(JSON.stringify(error))
    //       console.log('queryCalendarAndroidShuxin error', error)
    //     }
    //   })
    // },
    // deleteCalendarShuxin(){
    //   KNB.use('movie.removeCalendarEvent', {
    //     params: {
    //       eventUnionId: '1111',
    //       sceneToken: 'my-87bff41fea170162',
    //     },
    //     success: function (data) {
    //       alert(JSON.stringify(data))
    //       console.log('deleteCalendarShuxin res', data)
    //     },
    //     fail: function (error) {
    //       alert(JSON.stringify(error))
    //       console.log('deleteCalendarShuxin error', error)
    //     }
    //   })
    // },
    addCalendar: function addCalendar() {
      console.log('addCalendar');
      notifyCalendar({
        title: 'test-cl',
        start: Math.floor((Date.now() + 1000 * 60 * 60) / 1000) * 1000,
        alarmOffsets: '600,1800',
        eventUnionId: '1234567890',
        endTime: Math.floor((Date.now() + 1000 * 60 * 70) / 1000) * 1000
      });
    },
    queryCalendar: function queryCalendar() {
      console.log('queryCalendar');
      if (Drip.UA.osName === 'ios') {
        console.log('queryCalendar ios', Math.floor((Date.now() + 1000 * 60 * 60) / 1000), Math.floor((Date.now() + 1000 * 60 * 70) / 1000));
        KNB.use('movie.isCalendarEventExist', {
          params: {
            sceneToken: 'my-87bff41fea170162',
            startTime: Math.floor((Date.now() + 1000 * 60 * 60) / 1000),
            endTime: Math.floor((Date.now() + 1000 * 60 * 70) / 1000),
            title: 'test-cl',
            calendarTitle: '猫眼'
          },
          success: function success(res) {
            console.log('queryCalendar res', res);
          },
          fail: function fail(error) {
            console.log('queryCalendar error', error);
          }
        });
      }
    },
    queryCalendarAndroid: function queryCalendarAndroid() {
      console.log('queryCalendar android');
      KNB.use('movie.isCalendarEventExist', {
        params: {
          sceneToken: 'my-87bff41fea170162',
          eventUnionId: this.eventUnionIdandroid
        },
        success: function success(res) {
          console.log('queryCalendar res', res);
        },
        fail: function fail(error) {
          console.log('queryCalendar error', error);
        }
      });
    },
    deleteCalendar: function deleteCalendar() {
      console.log('deleteCalendar');
      if (Drip.UA.osName === 'ios') {
        KNB.use('movie.removeCalendarEvent', {
          params: {
            sceneToken: 'my-87bff41fea170162',
            eventId: this.eventIdios
          },
          success: function success(res) {
            console.log('deleteCalendar res', res);
          },
          fail: function fail(error) {
            console.log('deleteCalendar error', error);
          }
        });
      }
    },
    deleteCalendarAndroid: function deleteCalendarAndroid() {
      console.log('deleteCalendar android');
      KNB.use('movie.removeCalendarEvent', {
        params: {
          sceneToken: 'my-87bff41fea170162',
          eventUnionId: this.eventUnionIdandroid
        },
        success: function success(res) {
          console.log('deleteCalendar res', res);
        },
        fail: function fail(error) {
          console.log('deleteCalendar error', error);
        }
      });
    },
    clipboard: function clipboard() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var userBehavior, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userBehavior = {};
              _context.prev = 1;
              _context.next = 4;
              return Store.get('performance_detail_behavior_strategy');
            case 4:
              userBehavior = _context.sent;
              _context.next = 9;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
            case 9:
              result = copyTextToClipboard(JSON.stringify(userBehavior)); // eslint-disable-next-line no-console
              console.log(result);
              alert(result ? '复制成功' : '复制失败');
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 7]]);
      }))();
    },
    quickSwtich: function quickSwtich(e) {
      var env = e.target.dataset.env;
      if (!envList.includes(env)) return;
      if (env === 'product') {
        location.href = 'https://h5.dianping.com/app/myshow/#/';
      } else if (env === 'beta') {
        this.swimlane = '';
        this.openWithSwimlane();
      } else {
        this.swimlane = '3803-aakmg';
        this.openWithSwimlane();
      }
    },
    openSwimlane: function openSwimlane() {
      if (!this.swimlane) return;
      this.openWithSwimlane();
    },
    openUrl: function openUrl(e) {
      var url = e.target.dataset.url;
      this.openWithSwimlane(url);
    },
    openWithSwimlane: function openWithSwimlane() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
      var swimlane = this.swimlane;
      var _URL = new URL(url),
        protocol = _URL.protocol,
        hostname = _URL.hostname,
        pathname = _URL.pathname,
        search = _URL.search,
        hash = _URL.hash;
      location.href = "".concat(protocol, "//").concat(swimlane ? swimlane + '-' : '', "h5.51ping.com").concat(pathname).concat(search).concat(hash);
    },
    addOpenUrl: function addOpenUrl() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var addUrlList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!_this.addUrlTitle || !_this.addUrl)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return Store.get('url-list');
            case 4:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 7;
                break;
              }
              _context2.t0 = [];
            case 7:
              addUrlList = _context2.t0;
              addUrlList.push({
                title: _this.addUrlTitle,
                url: _this.addUrl
              });
              Store.set('url-list', addUrlList);
              _this.setOpenList();
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setOpenList: function setOpenList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var addUrlList;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Store.get('url-list');
            case 2:
              _context3.t0 = _context3.sent;
              if (_context3.t0) {
                _context3.next = 5;
                break;
              }
              _context3.t0 = [];
            case 5:
              addUrlList = _context3.t0;
              _this2.urlList = urlList.concat(addUrlList);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setUserInfo: function setUserInfo() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return User.getUserInfo();
            case 2:
              _context4.t0 = _context4.sent;
              if (_context4.t0) {
                _context4.next = 5;
                break;
              }
              _context4.t0 = {};
            case 5:
              userInfo = _context4.t0;
              _this3.userInfo = Object.keys(userInfo).reduce(function (obj, key) {
                var value = userInfo[key];
                if (value !== undefined && value !== '') {
                  obj[key] = value;
                }
                return obj;
              }, {});
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    copyItem: function copyItem(e) {
      var value = e.target.dataset.item;
      if (!value) return;
      var success = copyTextToClipboard(value);
      if (success) {
        this.$toast('复制成功');
      }
    },
    userLogin: function userLogin() {
      if (this.userInfo.isLogin) {
        User.logout();
      } else {
        User.login();
      }
    },
    // 打开扫一扫
    openScan: function openScan() {
      var _this4 = this;
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      KNB.scanQRCode({
        needResult: open ? 0 : 1,
        success: function success(res) {
          if (!open) {
            _this4.addUrl = res.scanResult;
          }
        }
      });
    }
  }
};